<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_center">
                    <p class="menu_center_tex_s">コメント履歴</p>
                    <p class="menu_center_tex_l">{{title}}</p>
                </div>
            </div>
        </div>
        <div class="main_unit">
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div class="comment_tbl_unit wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">
                <table>
                    <tbody>
                    <tr>
                          <th class="wd240 checkSetting_text_align">チェック項目</th>
                        <th class="wd240 checkSetting_text_align">氏名</th>
                        <th class="wd70 checkSetting_text_align">登録時刻</th>
                        <th class="wd720 checkSetting_text_align ">改善措置／コメント</th>
                    </tr>
                    <tr v-for="CheckComment in dailyCheckComments" :key="CheckComment.dailyCheckCommentId">
                        <td class="wd240 tbl_tex_left text_white_space">{{CheckComment.dailyCheckItemName}}</td>
                        <td class="wd240 tbl_tex_left text_white_space">{{CheckComment.staffName}}</td>
                        <td v-if="!buttonNo" class="wd70">{{CheckComment.createdTime}}</td>
                        <td v-else-if="buttonNo" class="wd70">{{CheckComment.createdDatetime}}</td>
                        <td class="tbl_tex_left wd720 text_white_space">
                            <p class="tbl_comment">{{CheckComment.comment}}</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'

    export default {
        name: 'DailyCheckCommentHistory',
        components: {
            PulseLoader
        },
        props:{
            title: String,
            pageId: Number
        },
        data: function () {
            return {
                isInitLoading:true,
                daily_check_page_id: 1,
                dailyCheckComments: [
                    {
                        "dailyCheckCommentId": null,
                        "staffName": "",
                        "createdTime": "",
                        "createdDatetime": "",
                        "comment": "",
                        "checkButtonNo": "",
                        "dailyCheckItemName": ""
                    }
                ]
            }
        },
        computed:{
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            buttonNo: function () {
                return this.dailyCheckComments[0].checkButtonNo === 99 ? true : false;
            }
        },
        created: function(){
            this.calc();
        },
        methods: {
            calc() {

                this.isInitLoading = true;

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var pageId = this.pageId;
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/daily_check_page/' + pageId + '/comment_history';

                this.$axios
                    .get(url)
                    .then(response => (this.dailyCheckComments = response.data.dailyCheckComments))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);
            }
        }
    }
</script>
